import useComponentsHelper from "@/modules/app/useComponentsHelper";
import { Card, CardContent, CardHeader, CardTitle, Stack } from "@altimateai/lego";
import {
  TeamMates,
  TeamMateConfig,
  TaskLabels,
  TeamMateActionType,
} from "@altimateai/ui-components/teammate";
import { useNavigate } from "react-router-dom";
import LearningsToggle from "./LearningsToggle";
import { postSendDatamateRequest } from "@/helpers/apis";
import { Typography } from "@altimateai/lego";
import { useBreadcrumb } from "@/components/breadcrumbs";
import { TeammatesTracking } from "@/lib/tracking/teammates";

const TeammatesComponent = () => {
  useBreadcrumb("Enable Coaching", {
    defaultParents: [{ label: "Settings", pathname: "/settings", noLink: true }],
  });
  const navigate = useNavigate();
  const { isComponentsApiInitialized } = useComponentsHelper();

  if (!isComponentsApiInitialized) {
    return null;
  }

  const onTeamMateSelect = async (teammate: TeamMateConfig, action: TeamMateActionType) => {
    switch (action) {
      case TeamMateActionType.REQUEST_ACCESS: {
        TeammatesTracking.accessRequested(teammate.key);
        const response = await postSendDatamateRequest(teammate.key);
        return response?.ok;
      }
      case TeamMateActionType.SEE_IN_ACTION:
        if (teammate.key === TaskLabels.ChartBot) {
          navigate(`/summary?ref=${teammate.key}`);
        }
        break;
      case TeamMateActionType.VIEW_DETAILS:
        TeammatesTracking.detailViewed(teammate.key);
        navigate(`/teammates/${teammate.key}`);
        break;

      default:
        break;
    }
  };

  return (
    <Stack direction="column">
      <Stack justify="between">
        <div>
          <Typography variant="page-heading">Enable Coaching</Typography>
        </div>
      </Stack>
      <Card>
        <CardHeader className="al-p-3 al-pb-0">
          <CardTitle>
            <Stack>
              AI Coaching <LearningsToggle />
            </Stack>
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p>
            If enabled, users can coach AI through specific instructions in “Coach AI” marked
            product areas. Coached AI can provide more custom and personalized experience to users.
          </p>
        </CardContent>
      </Card>
      <TeamMates client="SAAS" onSelect={onTeamMateSelect} />
    </Stack>
  );
};

export default TeammatesComponent;
